import React from 'react';
import Modal from 'react-responsive-modal';

import { Content } from '../styles';

const SuccessRecoveryModal = ({ open, close }) => (
  <Modal open={open} onClose={close} center>
    <Content>
      <h2>Verifique seu e-mail</h2>
      <p style={{ marginBottom: 0 }}>
        {'Um link de redefinição de senha foi enviado para o endereço de e-mail informado. Acesse o link e troque sua senha.'}
      </p>
    </Content>
  </Modal>
);

export default SuccessRecoveryModal;
